<ion-header class="ion-no-border ion-header-modal-mobile">
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-back-button
        id="back-modal-btn"
        data-cy="back-modal-btn"
        text=""
        (click)="returnToFilters()"
      >
      </ion-back-button>
    </ion-buttons>
    <ion-label>
      {{ pageTitle[selectedFilter] | translate }}
      <ng-container *ngIf="numberOfItemsSelected > 0">
        &nbsp;({{ numberOfItemsSelected }})
      </ng-container>
    </ion-label>
  </ion-toolbar>
</ion-header>

<ion-content
  class="ion-content-modal-mobile"
  [class.is-customers]="selectedFilter === 'customers'"
>
  <form
    *ngIf="!!formValue"
    [formGroup]="filtersFormGroup"
    (ngSubmit)="returnToFilters()"
  >
    <!-- Remember my selection toggle - only show for appropriate filters -->
    <ng-container
      *ngIf="selectedFilter !== 'deliveryDate' && selectedFilter !== 'seller'"
    >
      <ng-container
        *appShowSplit="[
          features.split_global_order_status_filter_defaults.name,
        ]"
      >
        <div class="filters-header-container">
          <div class="remember-my-selection-toggle-container" slot="fixed">
            <ion-label
              [class.active-selection]="
                selectedFiltersSummary[selectedFilter] > 0
              "
              >{{
                'i18n.orderStatusPage.rememberMySelection' | translate
              }}</ion-label
            >
            <ion-toggle
              *ngIf="selectedFilter === 'orderStatus'"
              formControlName="rememberOrderStatus"
            ></ion-toggle>
            <ion-toggle
              *ngIf="selectedFilter === 'customers'"
              formControlName="rememberCustomers"
            ></ion-toggle>
            <ion-toggle
              *ngIf="selectedFilter === 'deliveryMethod'"
              formControlName="rememberDeliveryMethod"
            ></ion-toggle>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Search bar below the toggle -->
    <div
      *ngIf="!!formValue && selectedFilter === 'customers'"
      class="searchbar-section"
      slot="fixed"
    >
      <ion-searchbar
        *ngIf="filters[selectedFilter].searchable"
        id="customers-searchbar"
        data-cy="customers-searchbar"
        class="search"
        mode="md"
        placeholder="{{ 'i18n.common.searchCustomers' | translate }}"
        (ionClear)="clearCustomerSearch()"
        (ionInput)="searchCustomer($event)"
      ></ion-searchbar>
    </div>

    <!-- Order Status -->
    <div *ngIf="selectedFilter === 'orderStatus'" formGroupName="orderStatus">
      <ion-list>
        <ion-item
          *ngFor="
            let filter of filters[selectedFilter].value | keyvalue: mapOrder
          "
        >
          <ion-checkbox
            class="order-status-checkbox"
            mode="ios"
            slot="end"
            [formControlName]="$any(filter.key)"
          >
            {{ $any(filter.value) | titlecase }}
          </ion-checkbox>
        </ion-item>
      </ion-list>
    </div>

    <!-- Customers -->
    <div *ngIf="selectedFilter === 'customers'" formGroupName="customers">
      <ion-list>
        <ng-container *ngFor="let filter of searchedCustomers">
          <ion-item class="customer">
            <ion-badge slot="start">
              {{ getFirstLetter(filter.customerName) }}
            </ion-badge>
            <ng-container
              *ngIf="filter.departments && filter.departments?.length > 0"
            >
              <ion-label>
                {{ filter.customerName | titlecase }}&nbsp;({{
                  filter.customerNumber
                }})
                <span> {{ filter.city | titlecase }}, {{ filter.state }} </span>
              </ion-label>
            </ng-container>

            <ion-checkbox
              *ngIf="!filter.departments || filter.departments?.length === 0"
              mode="ios"
              slot="end"
              [formControlName]="filter.customerNumber"
              class="filter-checkbox"
            >
              <span class="customer-name-filter_text">
                {{ filter.customerName | titlecase }}&nbsp;({{
                  filter.customerNumber
                }})
              </span>
              <br />
              <span class="city-name-filter_text">
                {{ filter.city | titlecase }}, {{ filter.state }}
              </span>
            </ion-checkbox>
          </ion-item>
          <ng-container
            *ngIf="filter.departments && filter.departments?.length > 0"
          >
            <ion-item
              *ngFor="let dept of filter.departments"
              [formGroupName]="filter.customerNumber"
              class="dept"
            >
              <ion-checkbox
                mode="ios"
                slot="end"
                [formControlName]="dept.departmentNumber"
                class="filter-checkbox"
              >
                {{ dept.departmentName | titlecase }}<br />({{
                  dept.departmentNumber
                }})
              </ion-checkbox>
            </ion-item>
          </ng-container>
        </ng-container>
      </ion-list>
      <div *ngIf="searchedCustomers.length === 0" class="no-customers-found">
        {{ 'i18n.orderStatusPage.noCustomersFound' | translate }}
      </div>
    </div>
    <div *ngIf="selectedFilter === 'deliveryDate'">
      <mat-card>
        <div class="delivery-date-info">
          <ion-icon name="calendar-outline"></ion-icon>
          <span class="date-range">
            {{ 'i18n.orderStatusPage.dateRange' | translate }}:&nbsp;
          </span>
          <span *ngIf="selectedRangeValue?.start" class="date">
            {{ selectedRangeValue.start.format('M/D/YYYY') }}
          </span>
          <span *ngIf="!selectedRangeValue?.start" class="date-placeholder">
            {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}
          </span>
          <span>&nbsp;-&nbsp;</span>
          <span *ngIf="selectedRangeValue?.end" class="date">
            {{ selectedRangeValue.end.format('M/D/YYYY') }}
          </span>
          <span *ngIf="!selectedRangeValue?.end" class="date-placeholder">
            {{ 'i18n.orderStatusPage.datePlaceholder' | translate }}
          </span>
        </div>
        <mat-calendar
          #calendar
          id="my-orders-filters-calendar-mobile"
          [minDate]="minCalendarDate"
          [selected]="selectedRangeValue"
          (selectedChange)="selectedDateRangeChange($event)"
        >
        </mat-calendar>
      </mat-card>
      <ng-container
        *appShowSplit="[
          features.split_global_order_status_filter_defaults.name,
        ]"
      >
        <div
          class="date-presets-container"
          data-cy="date-presets-container"
          formGroupName="deliveryDate"
        >
          <div class="date-presets-header" data-cy="date-presets-header">
            {{ 'i18n.orderStatusPage.selectPreset' | translate }}
          </div>
          <div class="date-presets-buttons" data-cy="date-presets-buttons">
            <button
              type="button"
              class="preset-button"
              data-cy="preset-today"
              (click)="selectPreset(DatePreset.Today)"
              [class.active]="activePreset === DatePreset.Today"
            >
              {{ 'i18n.orderStatusPage.today' | translate }}
            </button>
            <button
              type="button"
              class="preset-button"
              data-cy="preset-2days"
              (click)="selectPreset(DatePreset.TwoDays)"
              [class.active]="activePreset === DatePreset.TwoDays"
            >
              {{ 'i18n.orderStatusPage.twoDays' | translate }}
            </button>
            <button
              type="button"
              class="preset-button"
              data-cy="preset-3days"
              (click)="selectPreset(DatePreset.ThreeDays)"
              [class.active]="activePreset === DatePreset.ThreeDays"
            >
              {{ 'i18n.orderStatusPage.threeDays' | translate }}
            </button>
            <button
              type="button"
              class="preset-button"
              data-cy="preset-1week"
              (click)="selectPreset(DatePreset.OneWeek)"
              [class.active]="activePreset === DatePreset.OneWeek"
            >
              {{ 'i18n.orderStatusPage.oneWeek' | translate }}
            </button>
            <button
              type="button"
              class="preset-button"
              data-cy="preset-2weeks"
              (click)="selectPreset(DatePreset.TwoWeeks)"
              [class.active]="activePreset === DatePreset.TwoWeeks"
            >
              {{ 'i18n.orderStatusPage.twoWeeks' | translate }}
            </button>
            <button
              type="button"
              class="preset-button"
              data-cy="preset-3weeks"
              (click)="selectPreset(DatePreset.ThreeWeeks)"
              [class.active]="activePreset === DatePreset.ThreeWeeks"
            >
              {{ 'i18n.orderStatusPage.threeWeeks' | translate }}
            </button>
          </div>
          <div
            class="save-preset-container mobile"
            [class.disabled-toggle-container]="
              rememberDeliveryDatePresetControl.disabled
            "
            data-cy="save-preset-container"
          >
            <span data-cy="save-preset-label">{{
              'i18n.orderStatusPage.rememberDeliveryDatePreset' | translate
            }}</span>
            <ion-toggle
              [formControl]="rememberDeliveryDatePresetControl"
              data-cy="save-preset-toggle"
            ></ion-toggle>
          </div>
        </div>
      </ng-container>
    </div>
    <!-- Delivery Method -->
    <div
      *ngIf="selectedFilter === 'deliveryMethod'"
      formGroupName="deliveryMethod"
    >
      <ion-list>
        <ion-item
          *ngFor="
            let filter of filters[selectedFilter].value | keyvalue: mapOrder
          "
        >
          <ion-checkbox
            mode="ios"
            slot="end"
            [formControlName]="$any(filter.key)"
            class="filter-checkbox"
          >
            {{ $any(filter.value) }}
          </ion-checkbox>
        </ion-item>
      </ion-list>
    </div>

    <!-- Seller -->
    <div *ngIf="selectedFilter === 'seller'" formGroupName="seller">
      <ng-container *appShowSplit="[sellerFilterFeatureFlag]">
        <ion-searchbar
          id="seller-searchbar"
          data-cy="seller-searchbar"
          class="search"
          mode="md"
          placeholder="{{ 'i18n.common.search' | translate }}"
          (ionClear)="clearSellerSearch()"
          (ionInput)="searchSeller($event)"
        ></ion-searchbar>

        <ion-list class="seller-list">
          <ion-item lines="none" class="no-border">
            <ion-checkbox
              labelPlacement="end"
              [indeterminate]="isAnySellerSelected()"
              mode="ios"
              slot="start"
              (ionChange)="selectAllSellers($event.detail.checked)"
              [checked]="isAllSellersSelected()"
            >
              <span class="select-all-text">{{
                'i18n.orderStatusPage.selectAll' | translate
              }}</span>
            </ion-checkbox>
          </ion-item>

          <hr class="divider" />

          <!-- Sellers with expandable sections -->
          <div *ngFor="let seller of searchedSellers" class="seller-section">
            <div
              class="seller-header"
              (click)="toggleSellerExpanded(seller.id)"
            >
              <div class="seller-header-content">
                <ion-checkbox
                  [indeterminate]="isSellerIndeterminate(seller.id)"
                  [checked]="isSellerChecked(seller.id)"
                  mode="ios"
                  slot="start"
                  [value]="seller.id"
                  (ionChange)="sellerHeaderCheckboxChange($event, seller.id)"
                  (click)="$event.stopPropagation()"
                >
                </ion-checkbox>
                <div>
                  <span class="main-name"
                    >{{ seller.name }}
                    <br />
                    ({{ seller.tmId }})</span
                  >
                  <br />
                  <span class="sub-name">{{ seller.salesRoute }}</span>
                </div>
              </div>
              <ion-icon
                detail
                slot="end"
                [name]="
                  isSellerExpanded(seller.id) ? 'chevron-up' : 'chevron-down'
                "
              >
              </ion-icon>
            </div>

            <!-- Customer items under each seller, shown when expanded -->
            <div
              class="seller-customers"
              [class.expanded]="isSellerExpanded(seller.id)"
            >
              <div
                class="customer-item"
                *ngFor="let customer of seller.customers"
              >
                <ion-checkbox
                  mode="ios"
                  slot="start"
                  [value]="customer.id"
                  [formControlName]="seller.id + '_' + customer.id"
                >
                </ion-checkbox>
                <div>
                  <span class="main-name">{{ customer.name }}</span>
                  <br />
                  <span class="sub-name"> {{ customer.subtitle }}</span>
                  <br />
                  <span class="city-name-filter_text">
                    {{ customer.city | titlecase }}, {{ customer.state }}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </ion-list>
      </ng-container>
    </div>
  </form>
</ion-content>

<ion-footer class="ion-footer-modal">
  <ion-toolbar>
    <ion-buttons>
      <ion-button
        id="save-modal-btn"
        data-cy="save-modal-btn"
        class="usf-fill-green-dsktp-tblt-modal-button"
        (click)="returnToFilters()"
        [disabled]="hasIncompleteDateRange"
        translate
      >
        {{ 'i18n.common.save' }}
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
